import React, { useEffect, useState } from "react";
import { Spin, Typography } from "antd";
import { getLatestPhysioReviewAPI } from "../../../../services/physio.services";
import PhysioScalesReviewSummary from "../../../IpEMR/InspectionSummaries/Scales/PhysioScalesReviewSummary";
import { checkEmpty } from "../../../../helpers/utility";

const ReviewFormScales = ({ admissionId }) => {
  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!admissionId) return;
    let cancelled = false;
    setLoading(true);
    getLatestPhysioReviewAPI(admissionId)
      .then((res) => {
        if (!cancelled) {
          setFormData(res?.data?.data || null);
        }
      })
      .catch(() => {
        if (!cancelled) setFormData(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [admissionId]);

  if (loading) {
    return (
      <div style={{ padding: "12px 0", textAlign: "center" }}>
        <Spin tip="Loading scales..." />
      </div>
    );
  }

  if (!checkEmpty(formData?.scales)) {
    return (
      <Typography.Text type="secondary">
        No latest scales data available for this patient.
      </Typography.Text>
    );
  }

  return (
    <PhysioScalesReviewSummary
      formData={formData}
      admissionId={admissionId}
    />
  );
};

export default ReviewFormScales;
